import '../../styles/main.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import Dashboard from './Dashboard';
import AuthGate from './auth/AuthGate';

document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('root');
    if (container) {
        const root = createRoot(container);
        root.render(
            <React.StrictMode>
                <AuthGate>
                    <Dashboard />
                </AuthGate>
            </React.StrictMode>
        );
    }
});